module.exports = __webpack_public_path__ + "img/dreams_cn.4fbe18f.jpg";